import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const ADMIN_KEY_STORAGE = "am_admin_key";

export const adminApi = (key) =>
  axios.create({ baseURL: API, headers: { "X-Admin-Key": key } });

// Public
export const getDays = () => api.get("/days").then((r) => r.data);
export const getCurrentDay = () => api.get("/days/current").then((r) => r.data);
export const getEvents = (params) => api.get("/events", { params }).then((r) => r.data);
export const getNearby = (params) => api.get("/events/nearby", { params }).then((r) => r.data);
export const getAlerts = () => api.get("/alerts").then((r) => r.data);
export const geocode = (q) => api.get("/geocode", { params: { q } }).then((r) => r.data);
export const createProposal = (body) => api.post("/proposals", body).then((r) => r.data);
export const reportEnded = (id) => api.post(`/events/${id}/report-ended`).then((r) => r.data);
